import { TimePicker } from "antd";
import { Control, Controller } from "react-hook-form";

interface IProps {
  name: string;

  label: string;
  placeholder: string;
  control: Control<any, any>;
}

export default function LabeledTimeInput({
  name,
  label,
  placeholder,
  control,
}: IProps) {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={""}
      render={({
        field: { name, onBlur, ref, value, onChange, disabled },
        fieldState: { error },
      }) => (
        <div className="w-full">
          <label
            htmlFor={name}
            className="pl-1"
            style={{ color: "rgba(0,0,0,.7)", fontSize: ".85rem" }}
          >
            {label}
          </label>
          <TimePicker
            id={name}
            onChange={onChange}
            name={name}
            onBlur={onBlur}
            disabled={disabled}
            value={value}
            ref={ref}
            placeholder={placeholder}
            status={error ? "error" : undefined}
            className="w-full"
            size="large"
          />
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
